import { QuestionStatus } from '@exam-management/graphql';
import { Flex, SectionTitle } from '@shared/components';

import { EDITABLE_QUESTION_DETAILS_STATUSES } from '../../constants';
import { PropertiesFormSection } from '../properties-form-section';
import { PropertiesView } from '../properties-view';

interface PropertiesSectionProps {
  questionId?: string;
  readonly?: boolean;
  questionStatus?: QuestionStatus;
}

export default function PropertiesSection(props: Readonly<PropertiesSectionProps>) {
  const { questionId, readonly: isReadonly = false, questionStatus = QuestionStatus.Draft } = props;

  const isEditable = EDITABLE_QUESTION_DETAILS_STATUSES.includes(questionStatus) && !isReadonly;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Properties' />
      {isEditable ? <PropertiesFormSection questionId={questionId} /> : <PropertiesView />}
    </Flex>
  );
}
